var map = {
	"./AccommodationRequest/api": 182,
	"./AccommodationRequest/api/api": 652,
	"./AccommodationRequest/mocks/api": 589,
	"./Accomodation/api": 217,
	"./Accomodation/api/api": 654,
	"./Audits/api": 63,
	"./Audits/api/api": 656,
	"./Audits/mocks/api": 298,
	"./Contacts/api": 440,
	"./Contacts/api/api": 658,
	"./Contacts/mocks/api": 871,
	"./Content/api": 153,
	"./Content/api/api": 444,
	"./ContentPage/api": 362,
	"./ContentPage/api/api": 661,
	"./Core/api": 439,
	"./Core/mocks/api": 874,
	"./Events/api": 234,
	"./Events/api/api": 343,
	"./Events/mocks/api": 1091,
	"./Facilities/api": 758,
	"./Facilities/api/api": 446,
	"./Faq/api": 441,
	"./Faq/api/api": 447,
	"./Faq/mocks/api": 875,
	"./Feedback/api": 648,
	"./Feedback/api/api": 229,
	"./JourneyPlanner/api": 243,
	"./JourneyPlanner/api/api": 668,
	"./LoyaltyStamps/api": 99,
	"./LoyaltyStamps/api/api": 651,
	"./LoyaltyStamps/mocks/api": 795,
	"./Menus/api": 201,
	"./Menus/api/api": 662,
	"./Order/api": 68,
	"./Order/api/api": 340,
	"./Review/api": 189,
	"./Review/api/api": 663,
	"./ServiceRequest/api": 769,
	"./ServiceRequest/api/api": 443,
	"./ServiceRequestLight/api": 266,
	"./ServiceRequestLight/api/api": 673,
	"./ServiceRequestLight/mocks/api": 689,
	"./ServiceRequestLightHelpdesk/api": 338,
	"./ServiceRequestLightHelpdesk/api/api": 675,
	"./ServiceRequestLightHelpdesk/mocks/api": 876,
	"./Sites/api": 1104,
	"./Sites/api/api": 202,
	"./Stamps/api/api": 225,
	"./Suppliers/api": 442,
	"./Suppliers/api/api": 449,
	"./Suppliers/mocks/api": 877,
	"./Surveys/api": 649,
	"./Surveys/api/api": 339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3279;